interface TreeItem {
  bnName: string;
  children?: TreeItem[];
  id: number;
  label: string;
  value: string;
}

export const unitTreeDataConvert = (
  data: any,
  language?: string | null | undefined,
) => 
  data &&
  data.map((item: any) => {
    const { bnName, ...rest } = item;

    const updatedItem: TreeItem = {
      ...rest,
      label: language === "bn" ? bnName : rest.label,
    };

    if (rest.children && rest.children.length > 0) {
      updatedItem.children = unitTreeDataConvert(rest.children, language);
    }

    return updatedItem;
  });
